import React from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { WelcomeCardProps } from "./types";

export function WelcomeCard({
  title = "Welcome back!",
  subtitle = "Manage your business efficiently with the available tools",
  statistics = [],
}: WelcomeCardProps) {
  return (
    <Card className="mb-6 border-none shadow-4 surface-card">
      <div className="welcome-header text-center py-6 px-4 border-round-2xl flex flex-column align-items-center">
        <div className="welcome-icon bg-welcome-gradient shadow-3 inline-flex align-items-center justify-content-center w-6rem h-6rem border-circle mb-4">
          <i className="pi pi-home text-4xl text-white"></i>
        </div>

        <h2 className="text-4xl font-bold text-900 mb-3">{title}</h2>

        <p className="text-700 text-xl mb-4 line-height-3">{subtitle}</p>

        <div className="flex justify-content-center align-items-center gap-4 mt-4 flex-wrap">
          {statistics.map((stat, index) => (
            <React.Fragment key={index}>
              <div className="text-center">
                <div
                  className={`text-2xl font-bold ${stat.color || "text-primary"}`}
                >
                  {stat.value}
                </div>
                <div className="text-sm text-600">{stat.label}</div>
              </div>
              {index < statistics.length - 1 && (
                <Divider layout="vertical" className="hidden md:block" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </Card>
  );
}
